/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Secrets
 * API for managing Secrets on Cloud Services.
 *
 * The version of the OpenAPI document: 2023-11-28
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SecretServiceCreateAppBodyToJSON, SecretServiceCreateAppKVSecretBodyToJSON, SecretServiceCreateAwsDynamicSecretBodyToJSON, SecretServiceCreateAwsIAMUserAccessKeyRotatingSecretBodyToJSON, SecretServiceCreateAwsIntegrationBodyToJSON, SecretServiceCreateGatewayPoolBodyToJSON, SecretServiceCreateGcpDynamicSecretBodyToJSON, SecretServiceCreateGcpIntegrationBodyToJSON, SecretServiceCreateGcpServiceAccountKeyRotatingSecretBodyToJSON, SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON, SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON, SecretServiceCreateTwilioIntegrationBodyToJSON, SecretServiceCreateTwilioRotatingSecretBodyToJSON, SecretServiceSetTierBodyToJSON, SecretServiceUpdateAppBodyToJSON, SecretServiceUpdateAwsDynamicSecretBodyToJSON, SecretServiceUpdateAwsIAMUserAccessKeyRotatingSecretBodyToJSON, SecretServiceUpdateAwsIntegrationBodyToJSON, SecretServiceUpdateGatewayPoolBodyToJSON, SecretServiceUpdateGcpDynamicSecretBodyToJSON, SecretServiceUpdateGcpIntegrationBodyToJSON, SecretServiceUpdateGcpServiceAccountKeyRotatingSecretBodyToJSON, SecretServiceUpdateMongoDBAtlasIntegrationBodyToJSON, SecretServiceUpdateMongoDBAtlasRotatingSecretBodyToJSON, SecretServiceUpdateTwilioIntegrationBodyToJSON, SecretServiceUpdateTwilioRotatingSecretBodyToJSON, Secrets20231128CreateAppKVSecretResponseFromJSON, Secrets20231128CreateAppResponseFromJSON, Secrets20231128CreateAwsDynamicSecretResponseFromJSON, Secrets20231128CreateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON, Secrets20231128CreateAwsIntegrationResponseFromJSON, Secrets20231128CreateGatewayPoolResponseFromJSON, Secrets20231128CreateGcpDynamicSecretResponseFromJSON, Secrets20231128CreateGcpIntegrationResponseFromJSON, Secrets20231128CreateGcpServiceAccountKeyRotatingSecretResponseFromJSON, Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON, Secrets20231128CreateTwilioIntegrationResponseFromJSON, Secrets20231128CreateTwilioRotatingSecretResponseFromJSON, Secrets20231128GetAppResponseFromJSON, Secrets20231128GetAppSecretResponseFromJSON, Secrets20231128GetAppSecretVersionResponseFromJSON, Secrets20231128GetAwsDynamicSecretResponseFromJSON, Secrets20231128GetAwsIAMUserAccessKeyRotatingSecretConfigResponseFromJSON, Secrets20231128GetAwsIntegrationResponseFromJSON, Secrets20231128GetGatewayPoolCertificateResponseFromJSON, Secrets20231128GetGatewayPoolResponseFromJSON, Secrets20231128GetGcpDynamicSecretResponseFromJSON, Secrets20231128GetGcpIntegrationResponseFromJSON, Secrets20231128GetGcpServiceAccountKeyRotatingSecretConfigResponseFromJSON, Secrets20231128GetIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON, Secrets20231128GetRotatingSecretStateResponseFromJSON, Secrets20231128GetTwilioIntegrationResponseFromJSON, Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON, Secrets20231128GetUsageResponseFromJSON, Secrets20231128ListAppSecretVersionsResponseFromJSON, Secrets20231128ListAppSecretsResponseFromJSON, Secrets20231128ListAppsResponseFromJSON, Secrets20231128ListAwsDynamicSecretsResponseFromJSON, Secrets20231128ListAwsIntegrationsResponseFromJSON, Secrets20231128ListGatewayPoolGatewaysResponseFromJSON, Secrets20231128ListGatewayPoolIntegrationsResponseFromJSON, Secrets20231128ListGatewayPoolsResponseFromJSON, Secrets20231128ListGcpDynamicSecretsResponseFromJSON, Secrets20231128ListGcpIntegrationsResponseFromJSON, Secrets20231128ListIntegrationsResponseFromJSON, Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON, Secrets20231128ListOpenAppSecretVersionsResponseFromJSON, Secrets20231128ListTwilioIntegrationsResponseFromJSON, Secrets20231128OpenAppSecretResponseFromJSON, Secrets20231128OpenAppSecretVersionResponseFromJSON, Secrets20231128OpenAppSecretsResponseFromJSON, Secrets20231128UpdateAppResponseFromJSON, Secrets20231128UpdateAwsDynamicSecretResponseFromJSON, Secrets20231128UpdateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON, Secrets20231128UpdateAwsIntegrationResponseFromJSON, Secrets20231128UpdateGatewayPoolResponseFromJSON, Secrets20231128UpdateGcpDynamicSecretResponseFromJSON, Secrets20231128UpdateGcpIntegrationResponseFromJSON, Secrets20231128UpdateGcpServiceAccountKeyRotatingSecretResponseFromJSON, Secrets20231128UpdateMongoDBAtlasIntegrationResponseFromJSON, Secrets20231128UpdateMongoDBAtlasRotatingSecretResponseFromJSON, Secrets20231128UpdateTwilioIntegrationResponseFromJSON, Secrets20231128UpdateTwilioRotatingSecretResponseFromJSON, } from '../models';
/**
 *
 */
export class SecretServiceApi extends runtime.BaseAPI {
    /**
     */
    async createAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async createApp(organizationId, projectId, body) {
        const response = await this.createAppRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createAppKVSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAppKVSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppKVSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secret/kv`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAppKVSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAppKVSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAppKVSecret(organizationId, projectId, appName, body) {
        const response = await this.createAppKVSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAwsDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsIAMUserAccessKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsIAMUserAccessKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsIAMUserAccessKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsIAMUserAccessKeyRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createAwsIAMUserAccessKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createAwsIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateAwsIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createAwsIntegration(organizationId, projectId, body) {
        const response = await this.createAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     * Gateways
     */
    async createGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGatewayPool.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGatewayPoolBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     * Gateways
     */
    async createGatewayPool(organizationId, projectId, body) {
        const response = await this.createGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createGcpDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpDynamicSecret(organizationId, projectId, appName, body) {
        const response = await this.createGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpIntegration(organizationId, projectId, body) {
        const response = await this.createGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createGcpServiceAccountKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createGcpServiceAccountKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateGcpServiceAccountKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateGcpServiceAccountKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createGcpServiceAccountKeyRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createGcpServiceAccountKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasIntegration(organizationId, projectId, body) {
        const response = await this.createMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createMongoDBAtlasRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createMongoDBAtlasRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateMongoDBAtlasRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateMongoDBAtlasRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createMongoDBAtlasRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createMongoDBAtlasRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioIntegration(organizationId, projectId, body) {
        const response = await this.createTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, body: body });
        return await response.value();
    }
    /**
     */
    async createTwilioRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling createTwilioRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createTwilioRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceCreateTwilioRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128CreateTwilioRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async createTwilioRotatingSecret(organizationId, projectId, appName, body) {
        const response = await this.createTwilioRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, body: body });
        return await response.value();
    }
    /**
     */
    async deleteAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteApp(organizationId, projectId, name) {
        const response = await this.deleteAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.deleteAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async deleteAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling deleteAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.deleteAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async deleteAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteAwsIntegration(organizationId, projectId, name) {
        const response = await this.deleteAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling deleteGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGatewayPool(organizationId, projectId, gatewayPoolName) {
        const response = await this.deleteGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async deleteGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling deleteGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.deleteGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async deleteGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteGcpIntegration(organizationId, projectId, name) {
        const response = await this.deleteGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteMongoDBAtlasIntegration(organizationId, projectId, name) {
        const response = await this.deleteMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async deleteTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling deleteTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async deleteTwilioIntegration(organizationId, projectId, name) {
        const response = await this.deleteTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async getApp(organizationId, projectId, name) {
        const response = await this.getAppRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.getAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.getAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async getAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsIAMUserAccessKeyRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsIAMUserAccessKeyRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsIAMUserAccessKeyRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsIAMUserAccessKeyRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getAwsIAMUserAccessKeyRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getAwsIntegration(organizationId, projectId, name) {
        const response = await this.getAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling getGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGatewayPool(organizationId, projectId, gatewayPoolName) {
        const response = await this.getGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async getGatewayPoolCertificateRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGatewayPoolCertificate.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGatewayPoolCertificate.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling getGatewayPoolCertificate.');
        }
        const queryParameters = {};
        if (requestParameters.csrPem !== undefined) {
            queryParameters['csr_pem'] = requestParameters.csrPem;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/certificate`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGatewayPoolCertificateResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGatewayPoolCertificate(organizationId, projectId, gatewayPoolName, csrPem) {
        const response = await this.getGatewayPoolCertificateRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName, csrPem: csrPem });
        return await response.value();
    }
    /**
     */
    async getGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpDynamicSecret(organizationId, projectId, appName, name) {
        const response = await this.getGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpIntegration(organizationId, projectId, name) {
        const response = await this.getGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getGcpServiceAccountKeyRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getGcpServiceAccountKeyRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetGcpServiceAccountKeyRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getGcpServiceAccountKeyRotatingSecretConfig(organizationId, projectId, appName, name) {
        const response = await this.getGcpServiceAccountKeyRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name });
        return await response.value();
    }
    /**
     */
    async getIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getIntegration(organizationId, projectId, name) {
        const response = await this.getIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasIntegration(organizationId, projectId, name) {
        const response = await this.getMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getMongoDBAtlasRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetMongoDBAtlasRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getMongoDBAtlasRotatingSecretConfig(organizationId, projectId, appName, secretName) {
        const response = await this.getMongoDBAtlasRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getRotatingSecretStateRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getRotatingSecretState.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getRotatingSecretState.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/rotation-state`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetRotatingSecretStateResponseFromJSON(jsonValue));
    }
    /**
     */
    async getRotatingSecretState(organizationId, projectId, appName, secretName) {
        const response = await this.getRotatingSecretStateRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling getTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioIntegration(organizationId, projectId, name) {
        const response = await this.getTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name });
        return await response.value();
    }
    /**
     */
    async getTwilioRotatingSecretConfigRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling getTwilioRotatingSecretConfig.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetTwilioRotatingSecretConfigResponseFromJSON(jsonValue));
    }
    /**
     */
    async getTwilioRotatingSecretConfig(organizationId, projectId, appName, secretName) {
        const response = await this.getTwilioRotatingSecretConfigRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async getUsageRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling getUsage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage(organizationId, projectId) {
        const response = await this.getUsageRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async getUsage2Raw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getUsage2.');
        }
        const queryParameters = {};
        if (requestParameters.projectId !== undefined) {
            queryParameters['project_id'] = requestParameters.projectId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/usage`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128GetUsageResponseFromJSON(jsonValue));
    }
    /**
     */
    async getUsage2(organizationId, projectId) {
        const response = await this.getUsage2Raw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async listAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, name, type) {
        const response = await this.listAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, name: name, type: type });
        return await response.value();
    }
    /**
     */
    async listAppsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listApps.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listApps.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAppsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listApps(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, name) {
        const response = await this.listAppsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, name: name });
        return await response.value();
    }
    /**
     */
    async listAwsDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listAwsDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listAwsIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listAwsIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listAwsIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListAwsIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listAwsIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listAwsIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolGatewaysRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPoolGateways.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPoolGateways.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling listGatewayPoolGateways.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/gateways`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolGatewaysResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPoolGateways(organizationId, projectId, gatewayPoolName) {
        const response = await this.listGatewayPoolGatewaysRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPoolIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPoolIntegrations.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling listGatewayPoolIntegrations.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPoolIntegrations(organizationId, projectId, gatewayPoolName) {
        const response = await this.listGatewayPoolIntegrationsRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName });
        return await response.value();
    }
    /**
     */
    async listGatewayPoolsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGatewayPools.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGatewayPools.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGatewayPoolsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGatewayPools(organizationId, projectId) {
        const response = await this.listGatewayPoolsRaw({ organizationId: organizationId, projectId: projectId });
        return await response.value();
    }
    /**
     */
    async listGcpDynamicSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpDynamicSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listGcpDynamicSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpDynamicSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpDynamicSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpDynamicSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listGcpIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listGcpIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listGcpIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListGcpIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listGcpIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listGcpIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.capabilities) {
            queryParameters['capabilities'] = requestParameters.capabilities;
        }
        if (requestParameters.providers) {
            queryParameters['providers'] = requestParameters.providers;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, capabilities, providers) {
        const response = await this.listIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, capabilities: capabilities, providers: providers });
        return await response.value();
    }
    /**
     */
    async listMongoDBAtlasIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listMongoDBAtlasIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListMongoDBAtlasIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listMongoDBAtlasIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listMongoDBAtlasIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listOpenAppSecretVersionsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling listOpenAppSecretVersions.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling listOpenAppSecretVersions.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListOpenAppSecretVersionsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listOpenAppSecretVersions(organizationId, projectId, appName, secretName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listOpenAppSecretVersionsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async listTwilioIntegrationsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling listTwilioIntegrations.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling listTwilioIntegrations.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128ListTwilioIntegrationsResponseFromJSON(jsonValue));
    }
    /**
     */
    async listTwilioIntegrations(organizationId, projectId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listTwilioIntegrationsRaw({ organizationId: organizationId, projectId: projectId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     */
    async openAppSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecret(organizationId, projectId, appName, secretName) {
        const response = await this.openAppSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName });
        return await response.value();
    }
    /**
     */
    async openAppSecretVersionRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling openAppSecretVersion.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling openAppSecretVersion.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}/versions/{version}:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretVersionResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecretVersion(organizationId, projectId, appName, secretName, version) {
        const response = await this.openAppSecretVersionRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, version: version });
        return await response.value();
    }
    /**
     */
    async openAppSecretsRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling openAppSecrets.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling openAppSecrets.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        if (requestParameters.types) {
            queryParameters['types'] = requestParameters.types;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets:open`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128OpenAppSecretsResponseFromJSON(jsonValue));
    }
    /**
     */
    async openAppSecrets(organizationId, projectId, appName, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken, types) {
        const response = await this.openAppSecretsRaw({ organizationId: organizationId, projectId: projectId, appName: appName, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken, types: types });
        return await response.value();
    }
    /**
     */
    async rotateSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling rotateSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling rotateSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/secrets/{secret_name}:rotate`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async rotateSecret(organizationId, projectId, appName, secretName, body) {
        const response = await this.rotateSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, body: body });
        return await response.value();
    }
    /**
     */
    async setTierRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling setTier.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling setTier.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/billing/tier`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceSetTierBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async setTier(organizationId, body) {
        const response = await this.setTierRaw({ organizationId: organizationId, body: body });
        return await response.value();
    }
    /**
     */
    async updateAppRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateApp.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateApp.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateApp.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateApp.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAppBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAppResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateApp(organizationId, projectId, name, body) {
        const response = await this.updateAppRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsDynamicSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAwsDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsIAMUserAccessKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsIAMUserAccessKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/aws/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsIAMUserAccessKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsIAMUserAccessKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsIAMUserAccessKeyRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateAwsIAMUserAccessKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateAwsIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateAwsIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateAwsIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/aws/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateAwsIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateAwsIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateAwsIntegration(organizationId, projectId, name, body) {
        const response = await this.updateAwsIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGatewayPoolRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.gatewayPoolName === null || requestParameters.gatewayPoolName === undefined) {
            throw new runtime.RequiredError('gatewayPoolName', 'Required parameter requestParameters.gatewayPoolName was null or undefined when calling updateGatewayPool.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGatewayPool.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/gateway-pools/{gateway_pool_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"gateway_pool_name"}}`, encodeURIComponent(String(requestParameters.gatewayPoolName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGatewayPoolBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGatewayPoolResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGatewayPool(organizationId, projectId, gatewayPoolName, body) {
        const response = await this.updateGatewayPoolRaw({ organizationId: organizationId, projectId: projectId, gatewayPoolName: gatewayPoolName, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpDynamicSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpDynamicSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpDynamicSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/dynamic/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpDynamicSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpDynamicSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpDynamicSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateGcpDynamicSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/gcp/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpIntegration(organizationId, projectId, name, body) {
        const response = await this.updateGcpIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateGcpServiceAccountKeyRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateGcpServiceAccountKeyRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/gcp/secret/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateGcpServiceAccountKeyRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateGcpServiceAccountKeyRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateGcpServiceAccountKeyRotatingSecret(organizationId, projectId, appName, name, body) {
        const response = await this.updateGcpServiceAccountKeyRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateMongoDBAtlasIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateMongoDBAtlasIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/mongodb-atlas/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateMongoDBAtlasIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateMongoDBAtlasIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateMongoDBAtlasIntegration(organizationId, projectId, name, body) {
        const response = await this.updateMongoDBAtlasIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateMongoDBAtlasRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateMongoDBAtlasRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/mongodb-atlas/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateMongoDBAtlasRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateMongoDBAtlasRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateMongoDBAtlasRotatingSecret(organizationId, projectId, appName, secretName, body) {
        const response = await this.updateMongoDBAtlasRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, body: body });
        return await response.value();
    }
    /**
     */
    async updateTwilioIntegrationRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling updateTwilioIntegration.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateTwilioIntegration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/integrations/twilio/config/{name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateTwilioIntegrationBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateTwilioIntegrationResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateTwilioIntegration(organizationId, projectId, name, body) {
        const response = await this.updateTwilioIntegrationRaw({ organizationId: organizationId, projectId: projectId, name: name, body: body });
        return await response.value();
    }
    /**
     */
    async updateTwilioRotatingSecretRaw(requestParameters) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
            throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.appName === null || requestParameters.appName === undefined) {
            throw new runtime.RequiredError('appName', 'Required parameter requestParameters.appName was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.secretName === null || requestParameters.secretName === undefined) {
            throw new runtime.RequiredError('secretName', 'Required parameter requestParameters.secretName was null or undefined when calling updateTwilioRotatingSecret.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateTwilioRotatingSecret.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/secrets/2023-11-28/organizations/{organization_id}/projects/{project_id}/apps/{app_name}/rotating/twilio/secret/{secret_name}`.replace(`{${"organization_id"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"app_name"}}`, encodeURIComponent(String(requestParameters.appName))).replace(`{${"secret_name"}}`, encodeURIComponent(String(requestParameters.secretName))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SecretServiceUpdateTwilioRotatingSecretBodyToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => Secrets20231128UpdateTwilioRotatingSecretResponseFromJSON(jsonValue));
    }
    /**
     */
    async updateTwilioRotatingSecret(organizationId, projectId, appName, secretName, body) {
        const response = await this.updateTwilioRotatingSecretRaw({ organizationId: organizationId, projectId: projectId, appName: appName, secretName: secretName, body: body });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ListIntegrationsCapabilitiesEnum;
(function (ListIntegrationsCapabilitiesEnum) {
    ListIntegrationsCapabilitiesEnum["DYNAMIC"] = "DYNAMIC";
    ListIntegrationsCapabilitiesEnum["ROTATION"] = "ROTATION";
    ListIntegrationsCapabilitiesEnum["SYNC"] = "SYNC";
})(ListIntegrationsCapabilitiesEnum || (ListIntegrationsCapabilitiesEnum = {}));
